/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_RowInputs */

const en_features_ex_row = /** @type {(inputs: Features_Ex_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barbell row`)
};

const pl_features_ex_row = /** @type {(inputs: Features_Ex_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiosłowanie sztangą`)
};

/**
* | output |
* | --- |
* | "Barbell row" |
*
* @param {Features_Ex_RowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_row = /** @type {((inputs?: Features_Ex_RowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_RowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_row(inputs)
	return en_features_ex_row(inputs)
});